/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { Courier, CourierFromJSON } from './Courier';

/**
 * Available tokens for address formatting
 * @export
 * @interface AddressToken
 */
export interface AddressToken {
    /**
     * 
     * @type {string}
     * @memberof AddressToken
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof AddressToken
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AddressToken
     */
    example: string;
}

/**
 * Formatted address response
 * @export
 * @interface FormattedAddress
 */
export interface FormattedAddress {
    /**
     * 
     * @type {string}
     * @memberof FormattedAddress
     */
    addressNameFormat: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAddress
     */
    addressLine1Format: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAddress
     */
    addressLine2Format: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAddress
     */
    addressCityFormat: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAddress
     */
    addressStateFormat: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAddress
     */
    addressZipFormat: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAddress
     */
    addressCountryFormat: string;
}

/**
 * Preview format response
 * @export
 * @interface PreviewFormatResponse
 */
export interface PreviewFormatResponse {
    /**
     * 
     * @type {object}
     * @memberof PreviewFormatResponse
     */
    address: object;
    /**
     * 
     * @type {FormattedAddress}
     * @memberof PreviewFormatResponse
     */
    preview: FormattedAddress;
    /**
     * 
     * @type {object}
     * @memberof PreviewFormatResponse
     */
    sampleData: object;
}

/**
 * Formatted addresses response
 * @export
 * @interface FormattedAddressesResponse
 */
export interface FormattedAddressesResponse {
    /**
     * 
     * @type {object}
     * @memberof FormattedAddressesResponse
     */
    courier: object;
    /**
     * 
     * @type {object}
     * @memberof FormattedAddressesResponse
     */
    settings: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof FormattedAddressesResponse
     */
    addresses: Array<object>;
    /**
     * 
     * @type {object}
     * @memberof FormattedAddressesResponse
     */
    userData: object;
}

/**
 * Migration response
 * @export
 * @interface MigrationResponse
 */
export interface MigrationResponse {
    /**
     * 
     * @type {string}
     * @memberof MigrationResponse
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof MigrationResponse
     */
    addressesCreated: number;
    /**
     * 
     * @type {number}
     * @memberof MigrationResponse
     */
    existingAddresses?: number;
    /**
     * 
     * @type {Array<ShippingAddress>}
     * @memberof MigrationResponse
     */
    addresses?: Array<ShippingAddress>;
}

/**
 * 
 * @export
 * @interface ShippingAddress
 */
export interface ShippingAddress {
    /**
     * Display name for the shipping address (e.g., 'Miami Warehouse', 'Sea Freight', 'Additional Location')
     * @type {string}
     * @memberof ShippingAddress
     */
    name: string;
    /**
     * Type of shipping address
     * @type {string}
     * @memberof ShippingAddress
     */
    type: ShippingAddressTypeEnum;
    /**
     * Street address line 1
     * @type {string}
     * @memberof ShippingAddress
     */
    street1: string;
    /**
     * Street address line 2 (optional)
     * @type {string}
     * @memberof ShippingAddress
     */
    street2?: string;
    /**
     * City
     * @type {string}
     * @memberof ShippingAddress
     */
    city: string;
    /**
     * State or province
     * @type {string}
     * @memberof ShippingAddress
     */
    state: string;
    /**
     * ZIP or postal code
     * @type {string}
     * @memberof ShippingAddress
     */
    zip: string;
    /**
     * Country
     * @type {string}
     * @memberof ShippingAddress
     */
    country: string;
    /**
     * Template for recipient name formatting using tokens
     * @type {string}
     * @memberof ShippingAddress
     */
    addressNameTemplate: string;
    /**
     * Template for address line 2 formatting using tokens
     * @type {string}
     * @memberof ShippingAddress
     */
    addressLine2Template: string;
    /**
     * Whether this shipping address is active and available for use
     * @type {boolean}
     * @memberof ShippingAddress
     */
    isActive?: boolean;
    /**
     * Whether this is the default address for its type
     * @type {boolean}
     * @memberof ShippingAddress
     */
    isDefault?: boolean;
    /**
     * Sort order for displaying addresses
     * @type {number}
     * @memberof ShippingAddress
     */
    sortOrder?: number;
    /**
     * Warehouse preset this address was created from (links it to that warehouse's API toggle)
     * @type {string}
     * @memberof ShippingAddress
     */
    presetKey?: string | null;
    /**
     * Upload container of the tax-exempt certificate (tax-certs-<courierId>)
     * @type {string}
     * @memberof ShippingAddress
     */
    taxFreeCertificateContainer?: string | null;
    /**
     * Stored file name of the tax-exempt certificate
     * @type {string}
     * @memberof ShippingAddress
     */
    taxFreeCertificateFilename?: string | null;
    /**
     * Original file name of the tax-exempt certificate
     * @type {string}
     * @memberof ShippingAddress
     */
    taxFreeCertificateName?: string | null;
    /**
     * MIME type of the tax-exempt certificate
     * @type {string}
     * @memberof ShippingAddress
     */
    taxFreeCertificateContentType?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ShippingAddress
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ShippingAddress
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    courierId?: string;
    /**
     * 
     * @type {Courier}
     * @memberof ShippingAddress
     */
    courier?: Courier;
}

/**
 * @export
 */
export const ShippingAddressTypeEnum = {
    Air: 'air',
    Sea: 'sea',
    Express: 'express'
} as const;
export type ShippingAddressTypeEnum = typeof ShippingAddressTypeEnum[keyof typeof ShippingAddressTypeEnum];

/**
 * 
 * @export
 * @interface NewShippingAddress
 */
export interface NewShippingAddress {
    /**
     * Display name for the shipping address (e.g., 'Miami Warehouse', 'Sea Freight', 'Additional Location')
     * @type {string}
     * @memberof NewShippingAddress
     */
    name: string;
    /**
     * Type of shipping address
     * @type {string}
     * @memberof NewShippingAddress
     */
    type: NewShippingAddressTypeEnum;
    /**
     * Street address line 1
     * @type {string}
     * @memberof NewShippingAddress
     */
    street1: string;
    /**
     * Street address line 2 (optional)
     * @type {string}
     * @memberof NewShippingAddress
     */
    street2?: string;
    /**
     * City
     * @type {string}
     * @memberof NewShippingAddress
     */
    city: string;
    /**
     * State or province
     * @type {string}
     * @memberof NewShippingAddress
     */
    state: string;
    /**
     * ZIP or postal code
     * @type {string}
     * @memberof NewShippingAddress
     */
    zip: string;
    /**
     * Country
     * @type {string}
     * @memberof NewShippingAddress
     */
    country: string;
    /**
     * Template for recipient name formatting using tokens
     * @type {string}
     * @memberof NewShippingAddress
     */
    addressNameTemplate?: string;
    /**
     * Template for address line 2 formatting using tokens
     * @type {string}
     * @memberof NewShippingAddress
     */
    addressLine2Template?: string;
    /**
     * Whether this shipping address is active and available for use
     * @type {boolean}
     * @memberof NewShippingAddress
     */
    isActive?: boolean;
    /**
     * Whether this is the default address for its type
     * @type {boolean}
     * @memberof NewShippingAddress
     */
    isDefault?: boolean;
    /**
     * Sort order for displaying addresses
     * @type {number}
     * @memberof NewShippingAddress
     */
    sortOrder?: number;
    /**
     * Warehouse preset this address was created from (links it to that warehouse's API toggle)
     * @type {string}
     * @memberof NewShippingAddress
     */
    presetKey?: string | null;
    /**
     * Upload container of the tax-exempt certificate (tax-certs-<courierId>)
     * @type {string}
     * @memberof NewShippingAddress
     */
    taxFreeCertificateContainer?: string | null;
    /**
     * Stored file name of the tax-exempt certificate
     * @type {string}
     * @memberof NewShippingAddress
     */
    taxFreeCertificateFilename?: string | null;
    /**
     * Original file name of the tax-exempt certificate
     * @type {string}
     * @memberof NewShippingAddress
     */
    taxFreeCertificateName?: string | null;
    /**
     * MIME type of the tax-exempt certificate
     * @type {string}
     * @memberof NewShippingAddress
     */
    taxFreeCertificateContentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewShippingAddress
     */
    courierId?: string;
}

/**
 * @export
 */
export const NewShippingAddressTypeEnum = {
    Air: 'air',
    Sea: 'sea',
    Express: 'express'
} as const;
export type NewShippingAddressTypeEnum = typeof NewShippingAddressTypeEnum[keyof typeof NewShippingAddressTypeEnum];

/**
 * Check if a given object implements the ShippingAddress interface.
 */
export function instanceOfShippingAddress(value: object): value is ShippingAddress {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('street1' in value) || value['street1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('addressNameTemplate' in value) || value['addressNameTemplate'] === undefined) return false;
    if (!('addressLine2Template' in value) || value['addressLine2Template'] === undefined) return false;
    return true;
}

export function ShippingAddressFromJSON(json: any): ShippingAddress {
    return ShippingAddressFromJSONTyped(json, false);
}

export function ShippingAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShippingAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'street1': json['street1'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'city': json['city'],
        'state': json['state'],
        'zip': json['zip'],
        'country': json['country'],
        'addressNameTemplate': json['addressNameTemplate'],
        'addressLine2Template': json['addressLine2Template'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'presetKey': json['presetKey'] === undefined ? undefined : json['presetKey'],
        'taxFreeCertificateContainer': json['taxFreeCertificateContainer'] === undefined ? undefined : json['taxFreeCertificateContainer'],
        'taxFreeCertificateFilename': json['taxFreeCertificateFilename'] === undefined ? undefined : json['taxFreeCertificateFilename'],
        'taxFreeCertificateName': json['taxFreeCertificateName'] === undefined ? undefined : json['taxFreeCertificateName'],
        'taxFreeCertificateContentType': json['taxFreeCertificateContentType'] === undefined ? undefined : json['taxFreeCertificateContentType'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'courier': json['courier'] == null ? undefined : CourierFromJSON(json['courier']),
    };
}

export function ShippingAddressToJSON(json: any): ShippingAddress {
    return ShippingAddressToJSONTyped(json, false);
}

export function ShippingAddressToJSONTyped(value?: ShippingAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': value['type'],
        'street1': value['street1'],
        'street2': value['street2'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'country': value['country'],
        'addressNameTemplate': value['addressNameTemplate'],
        'addressLine2Template': value['addressLine2Template'],
        'isActive': value['isActive'],
        'isDefault': value['isDefault'],
        'sortOrder': value['sortOrder'],
        'presetKey': value['presetKey'],
        'taxFreeCertificateContainer': value['taxFreeCertificateContainer'],
        'taxFreeCertificateFilename': value['taxFreeCertificateFilename'],
        'taxFreeCertificateName': value['taxFreeCertificateName'],
        'taxFreeCertificateContentType': value['taxFreeCertificateContentType'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'id': value['id'],
        'courierId': value['courierId'],
        'courier': value['courier'],
    };
}

/**
 * Check if a given object implements the NewShippingAddress interface.
 */
export function instanceOfNewShippingAddress(value: object): value is NewShippingAddress {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('street1' in value) || value['street1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function NewShippingAddressFromJSON(json: any): NewShippingAddress {
    return NewShippingAddressFromJSONTyped(json, false);
}

export function NewShippingAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewShippingAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'street1': json['street1'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'city': json['city'],
        'state': json['state'],
        'zip': json['zip'],
        'country': json['country'],
        'addressNameTemplate': json['addressNameTemplate'] == null ? undefined : json['addressNameTemplate'],
        'addressLine2Template': json['addressLine2Template'] == null ? undefined : json['addressLine2Template'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'presetKey': json['presetKey'] === undefined ? undefined : json['presetKey'],
        'taxFreeCertificateContainer': json['taxFreeCertificateContainer'] === undefined ? undefined : json['taxFreeCertificateContainer'],
        'taxFreeCertificateFilename': json['taxFreeCertificateFilename'] === undefined ? undefined : json['taxFreeCertificateFilename'],
        'taxFreeCertificateName': json['taxFreeCertificateName'] === undefined ? undefined : json['taxFreeCertificateName'],
        'taxFreeCertificateContentType': json['taxFreeCertificateContentType'] === undefined ? undefined : json['taxFreeCertificateContentType'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function NewShippingAddressToJSON(json: any): NewShippingAddress {
    return NewShippingAddressToJSONTyped(json, false);
}

export function NewShippingAddressToJSONTyped(value?: NewShippingAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': value['type'],
        'street1': value['street1'],
        'street2': value['street2'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'country': value['country'],
        'addressNameTemplate': value['addressNameTemplate'],
        'addressLine2Template': value['addressLine2Template'],
        'isActive': value['isActive'],
        'isDefault': value['isDefault'],
        'sortOrder': value['sortOrder'],
        'presetKey': value['presetKey'],
        'taxFreeCertificateContainer': value['taxFreeCertificateContainer'],
        'taxFreeCertificateFilename': value['taxFreeCertificateFilename'],
        'taxFreeCertificateName': value['taxFreeCertificateName'],
        'taxFreeCertificateContentType': value['taxFreeCertificateContentType'],
        'courierId': value['courierId'],
    };
}

// Helper functions for additional interfaces
export function AddressTokenFromJSON(json: any): AddressToken {
    return AddressTokenFromJSONTyped(json, false);
}

export function AddressTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressToken {
    if (json == null) {
        return json;
    }
    return {
        'token': json['token'],
        'description': json['description'],
        'example': json['example'],
    };
}

export function AddressTokenToJSON(json: any): AddressToken {
    return AddressTokenToJSONTyped(json, false);
}

export function AddressTokenToJSONTyped(value?: AddressToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        'token': value['token'],
        'description': value['description'],
        'example': value['example'],
    };
}

export function FormattedAddressFromJSON(json: any): FormattedAddress {
    return FormattedAddressFromJSONTyped(json, false);
}

export function FormattedAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormattedAddress {
    if (json == null) {
        return json;
    }
    return {
        'addressNameFormat': json['addressNameFormat'],
        'addressLine1Format': json['addressLine1Format'],
        'addressLine2Format': json['addressLine2Format'],
        'addressCityFormat': json['addressCityFormat'],
        'addressStateFormat': json['addressStateFormat'],
        'addressZipFormat': json['addressZipFormat'],
        'addressCountryFormat': json['addressCountryFormat'],
    };
}

export function FormattedAddressToJSON(json: any): FormattedAddress {
    return FormattedAddressToJSONTyped(json, false);
}

export function FormattedAddressToJSONTyped(value?: FormattedAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        'addressNameFormat': value['addressNameFormat'],
        'addressLine1Format': value['addressLine1Format'],
        'addressLine2Format': value['addressLine2Format'],
        'addressCityFormat': value['addressCityFormat'],
        'addressStateFormat': value['addressStateFormat'],
        'addressZipFormat': value['addressZipFormat'],
        'addressCountryFormat': value['addressCountryFormat'],
    };
}

export function PreviewFormatResponseFromJSON(json: any): PreviewFormatResponse {
    return PreviewFormatResponseFromJSONTyped(json, false);
}

export function PreviewFormatResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreviewFormatResponse {
    if (json == null) {
        return json;
    }
    return {
        'address': json['address'],
        'preview': FormattedAddressFromJSON(json['preview']),
        'sampleData': json['sampleData'],
    };
}

export function PreviewFormatResponseToJSON(json: any): PreviewFormatResponse {
    return PreviewFormatResponseToJSONTyped(json, false);
}

export function PreviewFormatResponseToJSONTyped(value?: PreviewFormatResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        'address': value['address'],
        'preview': FormattedAddressToJSON(value['preview']),
        'sampleData': value['sampleData'],
    };
}

export function FormattedAddressesResponseFromJSON(json: any): FormattedAddressesResponse {
    return FormattedAddressesResponseFromJSONTyped(json, false);
}

export function FormattedAddressesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormattedAddressesResponse {
    if (json == null) {
        return json;
    }
    return {
        'courier': json['courier'],
        'settings': json['settings'],
        'addresses': json['addresses'],
        'userData': json['userData'],
    };
}

export function FormattedAddressesResponseToJSON(json: any): FormattedAddressesResponse {
    return FormattedAddressesResponseToJSONTyped(json, false);
}

export function FormattedAddressesResponseToJSONTyped(value?: FormattedAddressesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        'courier': value['courier'],
        'settings': value['settings'],
        'addresses': value['addresses'],
        'userData': value['userData'],
    };
}

export function MigrationResponseFromJSON(json: any): MigrationResponse {
    return MigrationResponseFromJSONTyped(json, false);
}

export function MigrationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrationResponse {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
        'addressesCreated': json['addressesCreated'],
        'existingAddresses': json['existingAddresses'] == null ? undefined : json['existingAddresses'],
        'addresses': json['addresses'] == null ? undefined : (json['addresses'] as Array<any>).map(ShippingAddressFromJSON),
    };
}

export function MigrationResponseToJSON(json: any): MigrationResponse {
    return MigrationResponseToJSONTyped(json, false);
}

export function MigrationResponseToJSONTyped(value?: MigrationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        'message': value['message'],
        'addressesCreated': value['addressesCreated'],
        'existingAddresses': value['existingAddresses'],
        'addresses': value['addresses'] == null ? undefined : (value['addresses'] as Array<any>).map(ShippingAddressToJSON),
    };
}
